import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import '../node_modules/materialize-css/dist/css/materialize.min.css';
import '../node_modules/materialize-css/dist/js/materialize.min.js';

import './App.css';

import NavBar from './components/navbar';
import LandingPage from './components/LandingPage';
import Footer from './components/footer';
import NotFound from './components/NotFound';
import About from './components/About';
import Work from './components/work';
import Contact from './components/contact';
import WorkDetail from './components/WorkDetail';


const Routes = ({ childProps }) =>
  <Switch>
    <Route path="/" exact component={LandingPage} props={childProps} />
    <Route path="/about" exact component={About} props={childProps} />
    <Route path="/work" exact component={Work} props={childProps} />
    <Route path="/work/:id" exact component={WorkDetail} props={childProps} />
    <Route path="/contact" exact component={Contact} props={childProps} />
    <Route component={NotFound} />
  </Switch>;


class App extends Component {
  state = {
    timer: null,
    counter: 256,
    color: 'rgb(256, 256, 256)',
    up: true,
  }
  componentDidMount = () => {
    let timer = setInterval(this.tick, 200);
    this.setState({timer});
  }
  componentWillUnmount = () => {
    this.clearInterval(this.state.timer);
  }
  tick = () => {
    let newRGBValue = 0
    if (this.state.up) {
      let newCount = this.state.counter - 1
      if (newCount <= 240) {
        newCount = 240
        this.setState({
          up: false
        })
      }
      newRGBValue = newCount
    } else {
      let newCount = this.state.counter + 1
      if (newCount >= 250) {
        newCount = 250
        this.setState({
          up: true
        })
      }
      newRGBValue = newCount
    }
    this.setState({
      counter: newRGBValue,
      color: `rgb(${newRGBValue}, 256, 256)`
    });
  }	
  render() {
		document.body.style.backgroundColor = this.state.color
    return (
      <div>
        <MuiThemeProvider>
        <Router>
          <Fragment>
            <NavBar color={this.state.color} />
            <Routes />
            <Footer color={this.state.color} />
          </Fragment>
        </Router>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js